import React, { Component } from 'react';
import {
    Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink,
    Col, Container, Row
} from 'reactstrap';
import { Link } from 'react-router-dom';
/*import './NavMenu.css';*/


import '../assets/css/bootstrap.min.css';

///*< !--Libraries Stylesheet-- >*/
/*import '../assets/lib/owlcarousel/assets/owl.carousel.min.css';*/
import '../assets/lib/animate/animate.min.css';

///*< !--JavaScript Libraries-- >*/
//import '../assets/lib/wow/wow.min.js';
//import '../assets/lib/easing/easing.min.js';
//import '../assets/lib/waypoints/waypoints.min.js';
//import '../assets/lib/counterup/counterup.min.js';
//import '../assets/lib/owlcarousel/owl.carousel.min.js';

///*<!--Template Javascript-- >*/
//import '../assets/js/main.js';

export class Footer extends Component {
    static displayName = Footer.name;

    render() {
        return (
            <div>

                {/*<!--parallax section starts here-->*/}
                <div class="footer-main">
                    <div class="footer-news pad-top-10 pad-bottom-10 parallax">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="parallax-div wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s">
                                        <h2 class="my-header color-white text-center text-uppercase">jewstechs</h2>
                                        <p>Thank you for visiting us. You can reach us through out contact page,
                                           call us via our phone number, or email us through our email address</p>
                                    </div>
                                </div>
                                {/*<!-- end col -->*/}
                            </div>
                            {/*<!-- end row -->*/}
                        </div>
                        {/*<!-- end container -->*/}
                    </div>
                </div>
                {/*<!--parallax section starts here-->*/}

                {/*<!-- ======= footer starts here ======= -->*/}
                <footer id="footer">

                    <div class="footer-top">
                        <div class="container wow fadeInUp" data-wow-delay="0.1s">
                            <div class="row">

                                <div class="col-lg-4 col-md-6 footer-links">
                                    <h4>jewstechs</h4>
                                    <p>
                                        <span class="bi bi-geo-alt me-3"></span>Nairobi Kenya<br/>
                                        <span class="bi bi-geo-alt me-3"></span>Nairobi South<br/>
                                        <span class="bi bi-geo-alt me-3"></span>Off Mombasa Road<br /><br/>                                        
                                        <span class="bi bi-phone me-3"></span>+254 792 188 931<br/>
                                        <span class="bi bi-phone me-3"></span>+254 792 026 263<br/>
                                        <span class="bi bi-envelope me-3"></span>
                                        <strong class="text-lowercase">info@jewstechs.com</strong><br/>
                                    </p>
                                </div>

                                <div class="col-lg-4 col-md-6 footer-links">
                                    <h4>our services</h4>
                                    <p class="text-capitalize">
                                        <span className="bi bi-check-all me-3"></span>CCTV Surveillance<br/>
                                        <span className="bi bi-check-all me-3"></span>biometrics & access control<br/>
                                        <span className="bi bi-check-all me-3"></span>networking<br/>
                                        <span className="bi bi-check-all me-3"></span>Virtualization Storage<br/>
                                        <span className="bi bi-check-all me-3"></span>backup and replication<br/>
                                        <span className="bi bi-check-all me-3"></span>remote offsite monitoring<br/>
                                        <span className="bi bi-check-all me-3"></span>ICT consultation<br/>
                                    </p>
                                </div>

                                <div class="col-lg-4 col-md-6 footer-links">
                                    <h4>why choose us</h4>
                                    <p class="text-capitalize">
                                        <span className="bi bi-clock me-3"></span>24/7 service availability<br />
                                        <span className="bi bi-people me-3"></span>Team collaborations<br />
                                        <span className="bi bi-briefcase me-3"></span>Professional experience<br /><br />
                                        <span className="bi bi-star me-3"></span>Best in the Industry<br />
                                        <span className="bi bi-credit-card me-3"></span>Affordable pricing<br />
                                        <span className="bi bi-tools me-3"></span>Maintenance services<br />
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="footer-container wow fadeInUp" data-wow-delay="0.1s">
                        <div class="container d-md-flex py-4">
                            <div class="me-md-auto text-center text-md-start">
                                <p class="copyright">
                                    &copy; Copyright at {new Date().getFullYear()} <strong>
                                    <span class="text-primary text-capitalize">jewstechs ltd</span></strong>
                                </p>
                            </div>
                            <div class="social-links text-center text-md-right pt-3 pt-md-0">
                                <a href="https://www.facebook.com/jewstechs-1990454" target="_blank" class="facebook"><i class="bi bi-facebook"></i></a>
                                <a href="https://mobile.twitter.com/jewstechs#" target="_blank" class="twitter"><i class="bi bi-twitter"></i></a>
                                <a href="https://www.instagram.com/jewstechs/?hl=en" target="_blank" class="instagram"><i class="bi bi-instagram"></i></a>
                                <a href="https://mobile.linkedin.com/jewstechs#" target="_blank" class="linkedin"><i class="bi bi-linkedin"></i></a>
                            </div>
                        </div>
                    </div>

                </footer>
                {/*<!-- ======= footer ends here======= -->*/}



            </div>
        );
    }
}
